export const failureRetryButtonContainerStyle = {
    marginTop: "49px"
};

export const failureImageContainerStyle = {
    paddingLeft: "8px",
    marginTop: "60px"
};
